module.exports = __webpack_public_path__ + "static/media/tr.a00c7dfb.svg";